import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Conect from "../../../Api/Conect";
import NotificationsAlert from "../../services/NotificationsAlert";

const MinecraftServerUI = () => {
  const history = useNavigate();
  const [logs, setLogs] = useState([]);
  const [command, setCommand] = useState(""); // Estado para o comando
  const logContainerRef = useRef(null);
  const socketRef = useRef(null); // Referência para o WebSocket

  useEffect(() => {
    const socket = new WebSocket(`wss://server.sakamottosann.com.br:1457`);
    socketRef.current = socket;
  
    socket.onmessage = (event) => {
      setLogs((prevLogs) => [...prevLogs, event.data]);
    };
  
    return () => {
      socket.close();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    verifyToken()
    // eslint-disable-next-line
  }, [])

  const verifyToken = async () => {

    let token = localStorage.getItem("worldofgus_token")

    if (token == null) {
      socketRef.current.close();
      history("/login")
    }
  };

  useEffect(() => {
    if (logContainerRef.current) {
      logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
    }
  }, [logs]);

  const startServer = async () => {
    try {
      const response = await Conect.post("/api/minecraft/start");
      NotificationsAlert("success", "", response.data)
    } catch (error) {
      console.error("Error starting server:", error);
    }
  };

  const stopServer = async () => {
    try {
      const response = await Conect.post("/api/minecraft/stop");
      NotificationsAlert("warning", "", response.data)
    } catch (error) {
      console.error("Error stopping server:", error);
    }
  };

  const clearLogs = () => {
    setLogs([]);
  };

  const sendCommand = () => {
    if (command && socketRef.current) {
      socketRef.current.send(command);
      setCommand(""); // Limpar o campo após o envio
    }
  };

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#1e1e1e",
        color: "#e1e1e1",
        minHeight: "100%",
        padding: "20px",
      }}
    >
      <div className="create-folder" style={{ marginBottom: "20px" }}>
        <button onClick={startServer} style={buttonStyle}>
          Iniciar Servidor
        </button>
        <button onClick={stopServer} style={buttonStyle}>
          Parar Servidor
        </button>
        <button onClick={clearLogs} style={buttonStyle}>
          Limpar Logs
        </button>
      </div>

      {/* Barra de comando */}
      <div style={{ display: "flex", marginBottom: "20px" }}>
        <input
          type="text"
          value={command}
          onChange={(e) => setCommand(e.target.value)}
          placeholder="Digite seu comando"
          style={commandInputStyle}
        />
        <button onClick={sendCommand} style={buttonStyleSend}>
          Enviar Comando
        </button>
      </div>

      <div id="logs" ref={logContainerRef} style={logStyle}>
        {logs.map((log, index) => (
          <div key={index}>{log}</div>
        ))}
      </div>
    </div>
  );
};

// const folderStyle = {
//   position: "relative",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   flexDirection: "column",
//   width: "calc(20% - 20px)",
//   height: "120px",
//   margin: "8px",
//   borderRadius: "8px",
//   backgroundColor: "#34495E",
//   boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//   transition: "transform 0.3s ease, background-color 0.3s ease",
//   color: "white",
//   textAlign: "center",
//   cursor: "pointer",
//   overflow: "hidden",
// };

const buttonStyle = {
  margin: "5px",
  padding: "10px 20px",
  fontSize: "16px",
  cursor: "pointer",
  borderRadius: "5px",
  backgroundColor: "#34495E",
  color: "white",
  border: "none",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  transition: "background-color 0.3s ease, transform 0.3s ease",
};

const buttonStyleSend = {
  padding: "5px 15px", // Diminui o padding do botão
  fontSize: "14px", // Diminui o tamanho da fonte
  cursor: "pointer",
  borderRadius: "5px",
  backgroundColor: "#34495E",
  color: "white",
  border: "none",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  transition: "background-color 0.3s ease, transform 0.3s ease",
  height: "30px", // Ajusta a altura do botão
};

const logStyle = {
  width: "100%",
  height: "420px",
  background: "#000",
  color: "#0f0",
  padding: "10px",
  overflowY: "auto",
  borderRadius: "5px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
};

const commandInputStyle = {
  padding: "5px",
  fontSize: "14px", // Diminui o tamanho da fonte
  width: "80%",
  marginRight: "10px",
  borderRadius: "5px",
  border: "none",
  backgroundColor: "#34495E",
  color: "white",
  height: "30px", // Ajusta a altura do campo de entrada
};

export default MinecraftServerUI;
